import * as React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router';

import * as Locale from '../model/locale';
import {AppRoute} from '../model/routes/main';


export interface PaginatorProps {
    page?: number;
    route: AppRoute;
    itemsPerPage: number;
    totalItems: number;
    maxVisible: number;
    textForKey?: Function;
    location?: any;
}

export interface PaginatorState {
    page: number;
}

@connect(
    state => ({textForKey: state.data.textForKey})
)
export class Paginator extends React.Component<PaginatorProps, PaginatorState> {

    render() {
        return (
            <nav>
                <ul className="pagination">
                    {this.buildPageLinks()}
                </ul>
            </nav>
        );
    }

    private buildPageLink(page: number, text: number | string) {
        let {query} = this.props.location;
        query = Object.assign({}, query, {page});
        return (
            <li key={text} className={page === this.props.page ? 'disabled active' : ''}>
                <Link to={this.props.route.path}
                      query={query}>
                    {text}
                </Link>
            </li>
        );
    }

    private buildPageLinks() {
        const totalPages = Math.ceil(this.props.totalItems / this.props.itemsPerPage),
            page = this.props.page,
            maxVisible = this.props.maxVisible;

        let startPage = 1,
            endPage = totalPages,
            pages = [];

        if (totalPages > maxVisible) {
            startPage = Math.max(1, page - Math.floor(maxVisible / 2));
            endPage = startPage + maxVisible - 1;

            if (endPage > totalPages) {
                endPage = totalPages;
                startPage = endPage - maxVisible + 1;
            }
        }

        pages.push(this.buildPageLink(1, this.props.textForKey(Locale.TEXT_PAGINATION_FIRST)));
        pages.push(this.buildPageLink(Math.max(1, page - 1), this.props.textForKey(Locale.TEXT_PAGINATION_PREVIOUS)));

        for (var i = startPage; i <= endPage; i++) {
            pages.push(this.buildPageLink(i, i));
        }
        
        pages.push(this.buildPageLink(Math.min(totalPages, page + 1), this.props.textForKey(Locale.TEXT_PAGINATION_NEXT)));
        pages.push(this.buildPageLink(totalPages, this.props.textForKey(Locale.TEXT_PAGINATION_LAST)));
        
        return pages;
    }
}
